import React from "react";

/** The LT+ mark, in the ink of the current sheet. */
export default function BrandMark({ theme, className }) {
  return (
    <img
      src={theme === "dark" ? "/LT+_white.png" : "/LT+_black.png"}
      alt="LTplus AG"
      className={className}
    />
  );
}
